import Head from "next/head";

import { META_TITLE_SUFFIX } from "@/constants/app";
import { formatAssetLink } from "@/util/magnolia";
import EventHero from "./EventHero";
import { NodeWithIsPreview, SmartEditableArea } from "@/util/SmartEditableArea";

export function EventsPage(props: NodeWithIsPreview<Wif.Mgnl.EventPage>): JSX.Element | null {
  const { title, metaDescription, main, altText, image, isPreview } = props;

  const articleImageUrl = image?.renditions?.["xs"]
    ? formatAssetLink(image.renditions["xs"].link, isPreview)
    : undefined;

  return (
    <>
      <Head>
        <title>{title + META_TITLE_SUFFIX}</title>
        <meta name="description" content={metaDescription} />
        {articleImageUrl && (
          <meta property="og:image" content={articleImageUrl} />
        )}
        {altText && <meta property="og:image:alt" content={altText} />}
      </Head>

      <EventHero {...props} />

      <SmartEditableArea isPreview={isPreview} slotNode={main} />
    </>
  );
}
